import { Component } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { ContactUsPageConfig } from 'src/app/interfaces/pageConfig';

@Component({
  selector: 'app-contact-us-v2',
  templateUrl: './contact-us-v2.component.html',
  styleUrl: './contact-us-v2.component.scss'
})
export class ContactUsV2Component {
  public page: ContactUsPageConfig;

  constructor(private configService: ConfigService) {
    this.page = this.configService.getPage('contactUs');
  }
}
